import { render, staticRenderFns } from "./LoadingInfo.vue?vue&type=template&id=e2c90aa4"
import script from "./LoadingInfo.vue?vue&type=script&lang=js"
export * from "./LoadingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VOverlay,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c90aa4')) {
      api.createRecord('e2c90aa4', component.options)
    } else {
      api.reload('e2c90aa4', component.options)
    }
    module.hot.accept("./LoadingInfo.vue?vue&type=template&id=e2c90aa4", function () {
      api.rerender('e2c90aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/LoadingInfo.vue"
export default component.exports